import { useLang } from "@/contexts/LanguageContext";
import { Plane, Train, Car, Bus } from "lucide-react";

const HowToReach = () => {
  const { t } = useLang();
  const items = [
    { icon: Plane, t: t.directions.airport, d: t.directions.airport_d },
    { icon: Train, t: t.directions.train, d: t.directions.train_d },
    { icon: Car, t: t.directions.car, d: t.directions.car_d },
    { icon: Bus, t: t.directions.ferry, d: t.directions.ferry_d },
  ];
  return (
    <section id="how-to-reach" className="py-20 md:py-28 bg-[#1E3A5F] text-white" data-testid="directions-section">
      <div className="max-w-7xl mx-auto px-5 md:px-10 lg:px-12">
        <div className="max-w-2xl mb-14">
          <p className="text-overline text-[#E3A857] mb-3">{t.directions.overline}</p>
          <h2 className="font-display text-4xl md:text-5xl leading-tight">{t.directions.title}</h2>
        </div>
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-5 mb-12">
          {items.map((it, i) => (
            <div
              key={it.t}
              data-testid={`direction-${i}`}
              className="bg-white/5 border border-white/10 rounded-xl p-6 hover:bg-white/10 transition"
            >
              <div className="w-12 h-12 rounded-full bg-[#E3A857]/20 flex items-center justify-center mb-4">
                <it.icon className="w-5 h-5 text-[#E3A857]" />
              </div>
              <h3 className="font-display text-xl mb-2">{it.t}</h3>
              <p className="text-sm text-white/70 leading-relaxed">{it.d}</p>
            </div>
          ))}
        </div>
        <div className="rounded-2xl overflow-hidden h-80 border border-white/10">
          <iframe
            title="map"
            data-testid="map-frame"
            className="w-full h-full"
            src="https://maps.google.com/maps?q=Traversa+IV+Maldariti+29b+89131+Reggio+Calabria&output=embed"
          />
        </div>
        <p className="text-xs text-white/50 mt-4 text-center">
          Traversa IV Maldariti, 29b — 89131 Reggio Calabria (RC) ·
          <a
            href="https://maps.app.goo.gl/o3KYuoG1AXw9CTvr7"
            target="_blank"
            rel="noreferrer"
            className="ml-2 underline hover:text-[#E3A857]"
            data-testid="gmaps-link"
          >
            Apri in Google Maps
          </a>
        </p>
      </div>
    </section>
  );
};

export default HowToReach;
